import LegacyPagination from 'nightwatch-web/components/legacy-pagination';
export default class UserNotificationsPaginationComponent extends LegacyPagination {}
